export const translations = {
  uk: {
    chooseLang: "Оберіть мову",
    loginGoogle: "Увійти через Google",
    loginApple: "Увійти через Apple",
    welcome: "ПРИВІТ",
    pts: "Б",
    cancel: "Скасувати",
    edit: "Редагувати",
    myPet: "Мій улюбленець",
    dog: "Собака",
    newPet: "Новий улюбленець",
    name: "Кличка",
    breed: "Порода",
    notSpec: "Не вказано",
    gender: "Стать",
    boy: "Хлопчик",
    girl: "Дівчинка",
    dob: "Дата народження",
    weight: "Вага",
    city: "Місто",
    chip: "Номер чіпа",
    medInfo: "Опис та історія хвороби",
    aiScanner: "AI Сканер",
    analyzing: "Аналізую...",
    scanResult: "📝 Скан документу:",
    save: "Зберегти",
    delProfile: "Видалити профіль",
    confirmDel: "Видалити профіль?",
    medCard: "Медична карта",
    add: "Додати",
    noReminders: "Нагадувань немає",
    logout: "Вийти з системи",
    chat: "Чат",
    profile: "Профіль",
    aiVet: "AI Вет",
    subs: "Підписки",
    locs: "Локації",
    radar: "Радар",
    services: "Послуги",
    radSearch: "Радіус пошуку",
    radKm: "км",
    inRad: "В радіусі",
    global: "Глобальні",
    emptyHere: "Тут поки порожньо. Стань першим!",
    distUnk: "Дистанція невідома",
    contact: "Зв'язатися",
    dm: "Особисті",
    noDm: "У вас ще немає особистих повідомлень.",
    you: "Ви:",
    writeAll: "Написати усім навколо...",
    write: "Написати...",
    clearChatAlert: "Очистити всі повідомлення?",
    patient: "Пацієнт",
    pasteKey: "Встав Groq API ключ (модель gpt-oss-120b)",
    activate: "Активувати",
    getFreeKey: "Отримати безкоштовний ключ Groq",
    askAbout: "Запитай про",
    thinking: "Думаю...",
    clearAiAlert: "Очистити історію діалогу з AI?",
    aiPrompt:
      "Ти професійний AI-ветеринар у додатку MyPaws. Пацієнт: {name}, порода: {breed}, вага: {weight}. Встановлені діагнози: {diagnoses}. Призначені ліки: {meds}. Алергії: {allergies}. Опис та історія хвороби: {features}. Відповідай на запитання власника українською мовою, емпатично та професійно.",
    scanPrompt:
      'Це медичний документ тварини. Знайди і витягни найважливіше. ПОВЕРНИ ВІДПОВІДЬ ТІЛЬКИ У ФОРМАТІ СУВОРОГО JSON! Формат: {"diagnoses": ["діагноз 1"], "meds": ["ліки 1"], "allergies": ["алергія 1"], "summary": "Детальний опис"}',
    subAll: "Всі",
    subFood: "Харчування",
    subHealth: "Здоровʼя",
    subCare: "Догляд",
    subShelter: "Притулки",
    subscribe: "Оформити",
    locAll: "Всі",
    locClinics: "Клініки",
    locStores: "Магазини",
    locParks: "Парки",
    locEvents: "Івенти",
    locShelters: "Притулки",
    searchLoc: "Шукати клініку чи адресу...",
    noLocs: "Нічого не знайдено",
    createEvent: "Створити свій івент",
    clickMap: "Клікніть на карту, щоб обрати місце",
    modFeatures: "Особливості",
    modDiag: "Діагнози",
    modMeds: "Ліки",
    modAllergies: "Алергії",
    noData: "Даних немає. Відскануйте медичний документ у режимі редагування.",
    close: "Закрити",
    modNewRem: "Нове нагадування",
    modTitle: "Назва",
    modType: "Тип",
    modVac: "Вакцинація",
    modPills: "Ліки",
    modCheckup: "Чекап",
    modDate: "Дата",
    modTime: "Час",
    modRec: "Повторення",
    modOnce: "Один раз",
    modMonth: "Щомісяця",
    mod6m: "Раз на 6 міс.",
    modYear: "Щороку",
    modCustom: "Свій інтервал (дні)",
    modNotify: "Сповіщення",
    modOn: "Увімкнути",
    modOff: "Вимкнути",
    modNewEvent: "Створити Івент",
    modEvDesc: "Івент буде створено за обраними координатами на карті.",
    modEvName: "Назва івенту",
    modEvPlace: "Опис місця",
    modEvTime: "Час (напр. Сб, 18:00)",
    modOfferSvc: "Запропонувати послугу",
    modSvcName: "Назва послуги",
    modPrice: "Ціна",
    modSvcDesc: "Опис послуги",
    publish: "Опублікувати",
    age: "Вік",
    months: "міс.",
    years: "р.",
    errorScan: "Не вдалося розпізнати текст",
  },
  en: {
    chooseLang: "Choose your language",
    loginGoogle: "Sign in with Google",
    loginApple: "Sign in with Apple",
    welcome: "HELLO",
    pts: "PTS",
    cancel: "Cancel",
    edit: "Edit",
    myPet: "My Pet",
    dog: "Dog",
    newPet: "New Pet",
    name: "Name",
    breed: "Breed",
    notSpec: "Not specified",
    gender: "Gender",
    boy: "Boy",
    girl: "Girl",
    dob: "Date of Birth",
    weight: "Weight",
    city: "City",
    chip: "Microchip Number",
    medInfo: "Medical History & Details",
    aiScanner: "AI Scanner",
    analyzing: "Analyzing...",
    scanResult: "📝 Document Scan:",
    save: "Save",
    delProfile: "Delete Profile",
    confirmDel: "Delete profile?",
    medCard: "Medical Records",
    add: "Add",
    noReminders: "No reminders",
    logout: "Log Out",
    chat: "Chat",
    profile: "Profile",
    aiVet: "AI Vet",
    subs: "Subs",
    locs: "Locations",
    radar: "Radar",
    services: "Services",
    radSearch: "Search Radius",
    radKm: "km",
    inRad: "Local",
    global: "Global",
    emptyHere: "It's empty here. Be the first!",
    distUnk: "Distance unknown",
    contact: "Contact",
    dm: "Direct Messages",
    noDm: "You have no direct messages yet.",
    you: "You:",
    writeAll: "Message everyone around...",
    write: "Message...",
    clearChatAlert: "Clear all local chat messages?",
    patient: "Patient",
    pasteKey: "Paste Groq API Key (gpt-oss-120b)",
    activate: "Activate",
    getFreeKey: "Get a free Groq key",
    askAbout: "Ask about",
    thinking: "Thinking...",
    clearAiAlert: "Clear AI chat history?",
    aiPrompt:
      "You are a professional AI Vet in the MyPaws app. Patient: {name}, breed: {breed}, weight: {weight}. Diagnoses: {diagnoses}. Medications: {meds}. Allergies: {allergies}. History: {features}. Answer the owner's questions in English, empathetically and professionally.",
    scanPrompt:
      'This is a pet medical document. Extract key info. RETURN ONLY STRICT JSON! Format: {"diagnoses": ["diagnosis 1"], "meds": ["medication 1"], "allergies": ["allergy 1"], "summary": "Detailed description"}',
    subAll: "All",
    subFood: "Food",
    subHealth: "Health",
    subCare: "Grooming",
    subShelter: "Shelters",
    subscribe: "Subscribe",
    locAll: "All",
    locClinics: "Clinics",
    locStores: "Stores",
    locParks: "Parks",
    locEvents: "Events",
    locShelters: "Shelters",
    searchLoc: "Search clinic or address...",
    noLocs: "Nothing found",
    createEvent: "Create Event",
    clickMap: "Click on the map to pick a location",
    modFeatures: "Details",
    modDiag: "Diagnoses",
    modMeds: "Medications",
    modAllergies: "Allergies",
    noData: "No data. Scan a medical document in Edit mode.",
    close: "Close",
    modNewRem: "New Reminder",
    modTitle: "Title",
    modType: "Type",
    modVac: "Vaccination",
    modPills: "Medication",
    modCheckup: "Checkup",
    modDate: "Date",
    modTime: "Time",
    modRec: "Recurrence",
    modOnce: "Once",
    modMonth: "Monthly",
    mod6m: "Every 6 months",
    modYear: "Yearly",
    modCustom: "Custom (days)",
    modNotify: "Notifications",
    modOn: "On",
    modOff: "Off",
    modNewEvent: "Create Event",
    modEvDesc: "Event will be created at the selected map coordinates.",
    modEvName: "Event Name",
    modEvPlace: "Location Description",
    modEvTime: "Time (e.g., Sat, 18:00)",
    modOfferSvc: "Offer a Service",
    modSvcName: "Service Name",
    modPrice: "Price",
    modSvcDesc: "Description",
    publish: "Publish",
    age: "Age",
    months: "mo",
    years: "y",
    errorScan: "Failed to parse text",
  },
};
